import isEmpty from "lodash/isEmpty";

interface IGetChannelProps {
    channel: string;
    selectedCategory: string;
}

export const brandSort = (a, b) => {
    const titleA = a.title.toLowerCase();
    const titleB = b.title.toLowerCase();
    if (titleA < titleB) {
        return -1;
    }
    if (titleA > titleB) {
        return 1;
    }
    return 0;
};

export const getChannel = ({ channel, selectedCategory }: IGetChannelProps) => {
    if (isEmpty(channel)) {
        return `brands,${selectedCategory || "all-brands"}`;
    }

    return channel;
};
